import React, { useContext } from 'react';
import AgreementHeaderTableCard from './AgreementHeaderTableCard';
import agreementHeaderColumnDefs from '../agreementHeaderColumnDefs';
import { AgreementHeaderContext } from '../Provider/AgreementHeaderProvider';

export const filterAddendumAgreements = agreementHeaderId => agreementHeaders => {
    const appliedTo = agreementHeaders.filter(
        agreementHeader =>
            agreementHeader.addendumId === agreementHeaderId && agreementHeader.addendumStatus === 'Applied'
    );

    return agreementHeaders.filter(agreementHeader => appliedTo.some(({ id }) => id === agreementHeader.parentId));
};

const title = 'Agreements Created by Addendum';

const columns = [
    agreementHeaderColumnDefs.companyName,
    agreementHeaderColumnDefs.startDate,
    agreementHeaderColumnDefs.endDate,
    agreementHeaderColumnDefs.agreementType
];

const AgreementsCreatedByAddendumTable = ({ isLoading }) => {
    const {
        agreementHeaderId,
        agreementState: { displayAddendumAgreementsTable }
    } = useContext(AgreementHeaderContext);

    if (!displayAddendumAgreementsTable) {
        return null;
    }

    return (
        <AgreementHeaderTableCard
            filter={filterAddendumAgreements(agreementHeaderId)}
            isLoading={isLoading}
            title={title}
            noItemsText="There are no agreements to show"
            columns={columns}
        />
    );
};

export default AgreementsCreatedByAddendumTable;
